<mat-card class="mat-card-sub" matTooltip="User that can be assigned access to filenet">
  <h1>User Access</h1>
  <mat-form-field appearance="outline" required>
    <mat-label>User Name</mat-label>
    <mat-select #user="ngModel" name="user" [(ngModel)]="username" required>
      <ngx-mat-select-search name="userSearch" [(ngModel)]="userSearch" [placeholderLabel]="'Search...'"
        [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

      <mat-option value="" disabled selected>Please select</mat-option>
      <mat-option *ngFor="let usr of stringFilterBy(userSearch,users) " [value]="usr.username">
        {{usr?.firstName}} {{usr?.lastName}} ({{usr?.username}})
      </mat-option>
    </mat-select>

  </mat-form-field>
  <div>
    <button matTooltip="Add User" [disabled]="!username" mat-raised-button color="primary" (click)="add(username)">Add
      User</button>
  </div>
  <ul class="table__control inline-list">
    <li>
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search for user" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </li>
  </ul>

  <div class="table__container">
    <table class="table__inner" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element"><a matTooltip="Delete" (click)="confirmDelete(element.username)">
            <!-- <img src="assets/images/icon-cross.svg" /> -->
            <mat-icon>delete</mat-icon>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="Username">
        <th mat-header-cell *matHeaderCellDef>Username</th>
        <td mat-cell *matCellDef="let row;let element;">{{ element?.username }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Firstname">
        <th mat-header-cell *matHeaderCellDef>Firstname</th>
        <td mat-cell *matCellDef="let row;let element;">{{ element?.firstName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Lastname">
        <th mat-header-cell *matHeaderCellDef>Lastname</th>
        <td mat-cell *matCellDef="let row;let element;">{{ element?.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="emailAddress">
        <th mat-header-cell *matHeaderCellDef>email Address</th>
        <td mat-cell *matCellDef="let row;let element;">{{ element?.emailAddress }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
      </tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{indirectRow:!row.direct}"></tr>
    </table>
  </div>
  <mat-paginator class="table__pagination" [pageSizeOptions]="[100,50,10,5]"></mat-paginator>
</mat-card>

<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>
